<ng-container *ngIf="docket; else loading">
  <h4 mat-dialog-title>Contract Preview</h4>
  <div mat-dialog-content>
    <div class="flex flex-col gap-4 justify-sstart items-stretch max-w-screen-lg w-full">
      <div class="flex flex-row justify-start items-center">
        <div class="w-1/3">
          <p>
            <a *ngIf="docket" matTooltip="View Customer" matTooltip-position="right" md-autohide="false"
              routerLink="/customer/{{ docket?.customer_id }}">
              {{ docket?.customer | customerName }}
            </a>
          </p>
          <p>{{ docket?.customer | customerAddress }}</p>
          <p>{{ docket?.customer | customerContactDetails }}</p>
        </div>
        <div class="w-1/3 text-center">
          <h3>{{ statusHeading }}</h3>
          <h5 *ngIf="!docket.account_reference">{{ docket?.id }}</h5>
          <h5 *ngIf="docket.account_reference">
            {{ docket?.account_reference }}
          </h5>
          <h5 *ngIf="docket.closed">
            {{ docket?.closed | amDateFormat : dateFormat }}
          </h5>
        </div>
        <div class="w-1/3 text-right flex flex-col justify-start items-end">
          <p>
            <strong>Status:</strong> {{ docket?.status }}
            <ng-container *ngIf="docket?.account_reference !== null">
              |
              <strong>Accounts Reference:</strong>
              {{ docket?.account_reference }}
              <span *ngIf="docket?.account === 1">(Account)</span>
              <span *ngIf="docket?.account === 0">(Cash Invoice)</span>
            </ng-container>
          </p>
          <p *ngIf="docket?.account_reference !== null">
            <strong>Tax Rate:</strong>
            {{ docket?.tax_rate | percent : '1.0-2' }}
          </p>
          <p><strong>Purchase Order:</strong> {{ docket?.purchase_order }}</p>
          <div class="flex flex-row gap-2">
            <button matTooltip="Print" mat-icon-button (click)="print()" class="hover:text-green-500 transition-colors">
              <mat-icon>print</mat-icon>
            </button>
            <button matTooltip="Download" mat-icon-button (click)="print(true)"
              class="hover:text-green-500 transition-colors">
              <mat-icon>file_download</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="flex flex-row w-full">
        <app-hire-item-list-v2 [docketId]="docket?.id" [defaultCurrency]="currency"
          [docketClosed]="docket?.closed !== null" [previewMode]="true"></app-hire-item-list-v2>
      </div>

      <div class="flex flex-col border border-gray-200 rounded-xs p-4">
        <h2 class="text-center py-2">Consumables</h2>
        <app-retail-item-list [docketId]="docket?.id" [canAdd]="false" [canEdit]="false"
          [currency]="docket?.currency_code" [currencyRate]="docket?.currency_rate" [parentType]="'hire docket'"
          [preview]="true"></app-retail-item-list>
      </div>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="end center" mat-dialog-actions>
    <button type="button" mat-flat-button (click)="close()">Close</button>
    <a mat-flat-button [color]="'primary'" [routerLink]="['docket', docket?.id]">View Contract/Invoice
    </a>
  </div>

  <iframe [style.display]="'none'" frameborder="0" #printFrame></iframe>
</ng-container>

<ng-template #loading>
  <p class="center">Loading contract...</p>
</ng-template>